export default __webpack_public_path__ + "static/media/e13.94d6018a.png";